if (!customElements.get('newsletter-form-verizon')) {
  customElements.define(
    'newsletter-form-verizon',

    class newsletterFormVerizon extends HTMLElement {
      constructor() {
        super();

        this.input = this.querySelector('.input-contact');
        this.containerMessages = this.querySelector('.message');
        this.submitBtn = this.querySelector('button[type="submit"]');
        this.form = this.querySelector('form');

        this.form.addEventListener('submit', (e) => {
          e.preventDefault();

          const form = this.form;
          const formData = new FormData(form);

          this.containerMessages.innerHTML = '';
          const span = document.createElement('span');

          fetch(`${window.internalApi.baseUrl}/users/subscribe`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              email: formData.get('email'),
            }),
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.error) {
                this.containerMessages.classList.add('warning-block');
                span.innerHTML = response.message;
              } else {
                this.containerMessages.classList.add('info-block');
                span.innerHTML = 'Thanks for joining!';
              }

              this.containerMessages.appendChild(span);
            })
            .catch((response) => {
              span.innerHTML = response.message;
              this.containerMessages.appendChild(span);
              this.containerMessages.classList.add('warning-block');
            })
            .finally(() => {
              this.containerMessages.classList.remove('hidden');
              this.form.reset();
            });
        });
      }
    },
  );
}
